import { Component, HostListener, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { lastValueFrom, take } from 'rxjs';
import { AppResource } from 'src/app/app.resource';
import { PathType } from 'src/app/core/enums/path-type.enum';
import { State } from 'src/app/core/state/core.state';
import * as fromInfo from 'src/app/core/state/info';
import * as fromPath from 'src/app/core/state/path';
import { Resource } from 'src/app/resources/resource';
import { environment } from 'src/environments/environment';
import { String } from 'typescript-string-operations';
import { getMetropolePhoneNumber } from '../../helpers/metropole-helper.service';
import { isMobile } from '../../utils/deviceUtils';
import { isPartner } from '../../utils/brandUtils';

@Component({
  selector: 'app-web-callback',
  templateUrl: './web-callback.component.html',
  styleUrls: ['./web-callback.component.scss']
})
export class WebCallBackComponent implements OnInit {
  show!: boolean;
  resource: Resource;
  currentPage!: string;

  url!: string;
  path!: PathType;
  phoneNumber!: string;

  get brand() {
    return environment.brand;
  }

  constructor(private resources: AppResource, private store: Store<State>) {
    this.resource = resources['resource'];
    this.show = false;
    this.show = false;
  }

  async ngOnInit() {
    this.store.select(fromInfo.selectCurrentPage).subscribe(res => {
      this.currentPage = res;
    });
    this.path = await (
      await lastValueFrom(this.store.select(fromPath.selectPath).pipe(take(1)))!
    ).pathType;

    this.phoneNumber = this.getPhoneNumber(this.path);
  }

  clickFunction() {
    this.show = !this.show;
  }

  callClientService(): void {
    if (isMobile()) {
      window.location.href = `tel:${this.phoneNumber}`;
    }
  }

  @HostListener('document:click', ['$event'])
  closeInfoModal() {
    this.show = false;
  }

  private getPhoneNumber(pathType: PathType) {
    switch (pathType) {
      case PathType.HOUSING_SOLIDARITY:
      case PathType.HOUSING_BAILLEURS_SOCIAUX:
        return this.resource.webcallback['phoneAHS'];
      case PathType.HOUSING_PARIS:
      case PathType.HOUSING_TOURCOING:
      case PathType.HOUSING_LILLE:
      case PathType.HOUSING_GRENOBLE:
      case PathType.HOUSING_CRETEIL:
      case PathType.HOUSING_MARSEILLE:
      case PathType.HOUSING_ETUDIANTE:
        const phoneNumber = getMetropolePhoneNumber(this.path);
        return String.format(this.resource.webcallback['phoneAMetropole'], phoneNumber);
      case PathType.HOUSING:
      default:
        return this.resource.webcallback['phoneAHC'];
    }
  }

  isPartner(brand: string): boolean {
    return isPartner(brand);
  }
}
